import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomeAndAssetsSteps } from '../../../../../../enums/income-and-assets-steps.enum';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { OtherIncomeSourceOptions } from '../other-income-source/other-income-source.component';
import { SubmitSteps } from '../../../../../../enums/submit-steps.enum';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

export enum SupportIncomeOptions {
  ChildSupport = 'Child Support',
  Alimony = 'Alimony',
  Disability = 'Disability',
  Other = 'Other',
}

@Component({
  selector: 'lgv-other-support-income',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './other-support-income.component.html',
  styleUrls: ['./other-support-income.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherSupportIncomeComponent {
  SupportIncomeOptions = SupportIncomeOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(IncomeAndAssetsSteps.OtherSupportIncome) ?? ''

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  private childSupportTasks: string[] = [
    "Child Support Order"
  ];

  private alimonyTasks: string[] = [
    "Divorce Decree"
  ];

  private disabilityTasks: string[] = [
    "Social Security Awards Letter"
  ];

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService,
  ) { }

  ngOnInit(): void {
    this.syncTasksWithAnswer(this.optionSelected);
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
  }

  onNext() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.OtherSupportIncome, this.optionSelected)
    this.clearAllTasks();
    this.syncTasksWithAnswer(this.optionSelected);
    this.goToSection(StepSection.Submit, SubmitSteps.Confirmation)
  }

  onBack() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.OtherSupportIncome, this.optionSelected)
    this.clearAllTasks();
    this.goToStep(IncomeAndAssetsSteps.OtherIncomeSource)
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

  private clearAllTasks(): void {
    [...this.childSupportTasks, ...this.alimonyTasks, ...this.disabilityTasks]
      .forEach(task => this.taskService.removeTask(task));
  }

  private syncTasksWithAnswer(answer: string): void {
    switch (answer) {
      case SupportIncomeOptions.ChildSupport:
        this.childSupportTasks.forEach(task => this.taskService.addTask(task));
        break;
      case SupportIncomeOptions.Alimony:
        this.alimonyTasks.forEach(task => this.taskService.addTask(task));
        break;
      case SupportIncomeOptions.Disability:
        this.disabilityTasks.forEach(task => this.taskService.addTask(task));
        break;
    }
  }
}
